import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-process-plant-uptime-calculator',
  templateUrl: './process-plant-uptime-calculator.component.html',
  styleUrls: ['./process-plant-uptime-calculator.component.css']
})
export class ProcessPlantUptimeCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  plantUt(n1,n2){
    var plantUpt=n1/n2;
    var plantUptpercent= plantUpt*100;
    var plantUptsimple= plantUptpercent.toFixed(2);
    return plantUptsimple ;
    }
}


// WEBPACK FOOTER //
// C:/my-dream-app/src/app/process-plant-uptime-calculator/process-plant-uptime-calculator.component.ts